.panel {
  display: flex;
  flex-direction: column;

  &.raised {
    .header {
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.08);
    }
  }

  &.opened {
    .header {
      .header-icon {
        transform: rotate(90deg);
      }
    }
    .content {
      display: flex;
      flex-direction: column;
    }
  }

  .header {
    padding: 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: var(--astral-primary-font);
    transition: all 0.15s ease-in-out;

    .header-content {
      display: flex;
    }
    .header-spacer {
      flex: 1;
    }
    .header-icon {
      transition: transform 0.25s ease-in-out;
    }
  }

  .content {
    height: 0;
    overflow: hidden;
    div[slot='content'] {
      font-family: var(--astral-primary-font);
      padding: 15px;
    }
  }
}
